export function getActiveTypeLabel(activeType: string) {
  switch (activeType) {
    case 'BUBBLE':
      return 'Bubble';
    case 'POPUP':
      return 'Pop-up';
    case 'LiveChat':
      return 'LiveChat';
    default:
      return 'None';
  }
}
